import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Pastor from "@/components/Pastor";
import Horarios from "@/components/Horarios";
import EnVivo from "@/components/EnVivo";
import Mensajes from "@/components/Mensajes";
import RadioTeaser from "@/components/RadioTeaser";
import Galeria from "@/components/Galeria";
import Ministerios from "@/components/Ministerios";
import Eventos from "@/components/Eventos";
import Ubicacion from "@/components/Ubicacion";
import Contacto from "@/components/Contacto";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import AdminPanel from "@/pages/AdminPanel";
import RadioPage from "@/pages/RadioPage";
import LibreriaPage from "@/pages/LibreriaPage";
import LibroPage from "@/pages/LibroPage";
import { CompraExitosa, CompraCancelada } from "@/pages/CompraResultado";
import LibreriaTeaser from "@/components/LibreriaTeaser";

const Home = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="bg-ink text-paper" data-testid="app-root">
      <div className="grain-overlay" />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Pastor />
        <Horarios />
        <EnVivo />
        <Mensajes />
        <RadioTeaser />
        <LibreriaTeaser />
        <Galeria />
        <Ministerios />
        <Eventos />
        <Ubicacion />
        <Contacto />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/panel" element={<AdminPanel />} />
          <Route path="/radio" element={<RadioPage />} />
          <Route path="/libreria" element={<LibreriaPage />} />
          <Route path="/libreria/exito" element={<CompraExitosa />} />
          <Route path="/libreria/cancelado" element={<CompraCancelada />} />
          <Route path="/libreria/:slug" element={<LibroPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" toastOptions={{ style: { background: '#15282F', color: '#F4F1E6', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 0 } }} />
    </>
  );
}

export default App;
